const map_config_store = {
    subscribers:{},
    options:{
        popup:{
            type:'',
            obj_id:'',
            obj:null,
            show:false
        }
    },
    setPopupOptions(options = {}){
        this.options.popup = options
        this.publish('SET_POPUP_OPTIONS', options)
    },
    subscribe(topic, callback){
        if(!this.subscribers[topic]){
            this.subscribers[topic] = []
        }
        this.subscribers[topic].push(callback)
    },
    publish(topic, data){
        if(this.subscribers[topic]){
            this.subscribers[topic].forEach(callback => {
                callback(data);
            });
        }
    }
}

export default map_config_store